import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { ExpensesSubCategory } from "../expenses-sub-category/expenses-sub-category.entity";
import { Expenses } from "../expenses/entity/expenses-entity";


@Entity('expenses_category')
export class ExpensesCategory {

  @PrimaryGeneratedColumn("increment",{name:'expenses_category_id'})
  expensesCategoryId:number;

  @Column("char",{
      nullable:false,
      length:50,
      name:"expenses_category"
      })
  // @Index({ unique: true })
  expensesCategory:string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;
  
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      default:1,
      name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;


  @OneToMany(type => ExpensesSubCategory, expensesCategory => expensesCategory.expensesCategoryInfo)
  expensesSubCategoryInfo: ExpensesSubCategory[];

  @OneToMany(type => Expenses, expenses => expenses.expensesCategoryInfo)
  expensesInfo: Expenses[];

  
 

}
